import { t } from 'Src/i18n';
import {
  CHILDCARE_FILTER_FACET_ID,
  CHILDCARE_FILTER_FACET_LABELS,
  CHILDCARE_FILTER_FACET_LABELS_PREFIX,
  FLIGHT_DURATION_FACET_ID,
  FLIGHT_DURATION_FACET_LABELS,
  FLIGHT_DURATION_FACET_LABELS_PREFIX,
  GROUP_STRING,
  NON_LOCALIZED_TYPES_OF_STAY_FACET_RESORT_TYPES,
  SEASON_FACET_ID,
  SEASON_FACET_LABELS,
  SEASON_FACET_LABELS_PREFIX,
  TYPES_OF_STAY_FACET_ID,
  TYPES_OF_STAY_FACET_LABELS,
  TYPES_OF_STAY_FACET_LABELS_PREFIX,
  FILTERABLE_FACETS_TRACKING_CONFIG,
} from 'Utils/faceting/constants';

function getLabelGA(facetId) {
  switch (facetId) {
    case 'activities':
      return 'whichActivities';

    case 'destinations':
      return 'whichDestinations';

    default:
      // 'when', 'who', 'where'
      return facetId;
  }
}

export const getActiveFacetTabTrackingData = ({ facetId }: { facetId: string }) => ({
  actionGA: 'smartCriterias',
  labelGA: getLabelGA(facetId),
});
export const getFacetLocalizedLabelKey = (facetValue: string) => {
  if (facetValue?.startsWith(GROUP_STRING)) {
    return facetValue.replace(GROUP_STRING, '');
  }

  const [firstPart, secondPart] = facetValue.split('_');
  // Some facet values are localized so we need to extract the first part of the value that is the same for every locale to identify which value we are dealing with (example of some values returned by Pertimm for types of stay filter: ['0_JOYVIEW', '0_TOUR', '3_3 tridents', '3_三颗海神戟']
  return secondPart && NON_LOCALIZED_TYPES_OF_STAY_FACET_RESORT_TYPES.includes(secondPart)
    ? secondPart
    : firstPart;
};
export const getTypesOfStayFacetBadgeIconProps = ({
  facetBadgeIcons,
  facetLabel,
  facetValue,
}: {
  facetBadgeIcons: any;
  facetLabel: string;
  facetValue: string;
}) => {
  return { ...facetBadgeIcons[getFacetLocalizedLabelKey(facetValue)], alt: facetLabel };
};
export const getFacetLocalizedLabel = ({
  facetValue,
  facetLabels,
}: {
  facetValue: string;
  facetLabels: any;
}) => {
  const splitedValue = facetValue.split('_');
  const labelKey = getFacetLocalizedLabelKey(facetValue);
  const localizedLabel = facetLabels[labelKey]
    ? t(facetLabels[labelKey])
    : splitedValue[1] || facetValue;
  return localizedLabel;
};

const getFacetTrackingSuffix = (name: string, value: string | boolean) => {
  const stringValue = value.toString();
  const [firstPart, secondPart] = stringValue.split('_');
  const labelKey = getFacetLocalizedLabelKey(stringValue);

  switch (name) {
    case CHILDCARE_FILTER_FACET_ID:
      return (
        CHILDCARE_FILTER_FACET_LABELS[labelKey]?.replace(
          CHILDCARE_FILTER_FACET_LABELS_PREFIX,
          '',
        ) || firstPart.toLowerCase()
      );

    case FLIGHT_DURATION_FACET_ID:
      return (
        FLIGHT_DURATION_FACET_LABELS[labelKey]?.replace(FLIGHT_DURATION_FACET_LABELS_PREFIX, '') ||
        firstPart.toLowerCase()
      );

    case SEASON_FACET_ID:
      return (
        SEASON_FACET_LABELS[labelKey]?.replace(SEASON_FACET_LABELS_PREFIX, '') ||
        firstPart.toLowerCase()
      );

    case TYPES_OF_STAY_FACET_ID:
      return (
        TYPES_OF_STAY_FACET_LABELS[labelKey]?.replace(TYPES_OF_STAY_FACET_LABELS_PREFIX, '') ||
        secondPart.toLowerCase()
      );

    default:
      return stringValue.replace(/[|\s]/g, '_').toLowerCase();
  }
};

export const trackFilterChange = (name: string) => {
  const trackingConfig = FILTERABLE_FACETS_TRACKING_CONFIG.find(
    ({ id }) => id === name.replace('[]', ''),
  );

  if (!trackingConfig) {
    return;
  }

  return `${trackingConfig.trackingPrefixLabel}`;
};
export const trackFacetChange = (name: string, checked: boolean, value: string | boolean) => {
  if (!checked) {
    return;
  }

  const labelSuffix = getFacetTrackingSuffix(name, value);
  const trackingPrefixLabel = trackFilterChange(name);

  if (!trackingPrefixLabel) {
    return;
  }

  return `${trackingPrefixLabel}_${labelSuffix}`;
};
export const onClearFacets = (
  clearFacetList: (categoryId: string) => void,
  id: string,
  templateConfig: FacetTemplateConfig,
) => {
  if (!templateConfig) {
    return;
  }

  clearFacetList(id);
  templateConfig.facetLists.forEach(({ id: facetListId }) => {
    clearFacetList(facetListId);
  });
};
